// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Bxhi6","notes":"Notes_notes__3MyHB"};